import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
const info = {
    title: "子表汇总",
    title_i18n: "{\"zh\": \"子表汇总\", \"en\": \"SheetStatistic\"}",
    type: "sheetStatistic",
    icon: "h-icon-all-text-t",
    dataItemType: DataItemType.ShortText,
    formControllerType: FormControlType.SheetStatistic,
    group: "",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
    },
};
